import React from "react";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
} from "@material-ui/core";
import moment from "moment";

const FilterDataRange = ({ dates, handleDates, applyFilter, resetFilter, visible, handleOpen, handleClose, hideButton }) => {

	// Function to format date(s) correctly for the button label
	const formatDateLabel = () => {
		if (!dates) return "Filter by Date";

		if (Array.isArray(dates) && dates.length === 2) {
			return `${moment(dates[0]).format("DD/MM/YYYY")} - ${moment(dates[1]).format("DD/MM/YYYY")}`;
		}
		return "Filter by Date";
	};

	return (
		<div>
			{!hideButton && (
				<Button
					label={formatDateLabel()}
					icon="pi pi-calendar"
					className="p-button-outlined p-button-secondary"
					onClick={(e) => handleOpen(e, 'showDateModel')} />
			)}

			<Dialog
				open={visible}
				onClose={() => handleClose('closeDateModel')}
				aria-labelledby="filter-date-dialog-title"
			>
				<DialogTitle
					id="filter-date-dialog-title"
					className="custom-dialog-header"
				>
					<div>Select Date Range</div>
					<div
						className="dialog-close"
						onClick={() => handleClose("closeDateModel")}
					>
						<i className="icon-modal-close"></i>
					</div>
				</DialogTitle>
				<DialogContent className="CHA-dialog-content-area">
					<div className="p-fluid">
						<Calendar
							value={dates}
							onChange={(e) => handleDates(e.value)}
							selectionMode="range"
							showIcon
							readOnlyInput
							placeholder="Select date or range"
							className="w-full"
							yearNavigator
							yearRange="1900:2100"
							manualInput
						/>
					</div>
				</DialogContent>
				<DialogActions className="p-p-0 dialog-footer1">
					<Button
						className="primary-btn1"
						onClick={() => resetFilter()}
					>
						Reset
					</Button>
					<Button
						className="primary-btn"
						onClick={() => applyFilter()}
					>
						Apply
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default FilterDataRange;
